export const TOOL_TASK = 'unassign-accounts-entitlements';
export const TOOL_TITLE = 'Unassign Entitlements From Accounts';
export const TOOL_PROGRESS_LABEL = 'Progress of unassigning entitlements from accounts...';
export const FILE_NAME = 'Unassign-entitlements-from-accounts-report';
export const TOOL_STACK_OVERFLOW_MESSAGE = 'Please try again once unassigning entitlements to accounts finishes';
export const FILE_HEADERS = {
    accountId: 'Account Id',
    accountName: 'Account Name',
    role: 'Role',
    resources: 'Resources',
    grantName: 'Grant Name',
    actionStatus: 'Action Status',
};
